import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { RolesEnum } from 'src/app/models/users/roles/enums/roles';
import { BusinessPartnersService } from 'src/app/services/business-partners.service';
import { InboundService } from 'src/app/services/inbound.service';
import { LocationService } from 'src/app/services/location.service';
import { OutboundService } from 'src/app/services/outbound.service';
import { SharedService } from 'src/app/services/shared.service';
import { SkuService } from 'src/app/services/sku.service';

import Swal from 'sweetalert2';

export interface DialogData {
  type: RolesEnum;
  id?: any;
}

@Component({
  selector: 'app-import-file',
  templateUrl: './import-file.component.html'
})
export class ImportFileComponent implements OnInit {
  downloadLoader = false;
  loading = false;
  otherAttachments = [];
  isSubmitted = false;
  maxFiles = 1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<ImportFileComponent>,
    public translate: TranslateService,
    private inboundService: InboundService,
    private outboundService: OutboundService,
    private sharedService: SharedService,
    private locationService: LocationService,
    private toastr: ToastrService,
    private skuService:SkuService,
    private businessPartnersService:BusinessPartnersService
  ) { }

  ngOnInit(): void {
  }

  saveRecord() {
    this.isSubmitted = true;
    if (this.otherAttachments && this.otherAttachments.length) {
      this.loading = true;
      const formData = new FormData();
      this.otherAttachments.forEach((file: any) => {
        if (!file.id) {
          formData.append('file', file, file.name);
        }
      });
      let serviceTarget = this.inboundService.importFile(formData);
      if (this.data.type === RolesEnum.OutboundNotesList) {
        serviceTarget = this.outboundService.importSimpleSheet(formData);
      } else if (this.data.type === RolesEnum.LocationsList) {
        serviceTarget = this.locationService.importExcelFile(this.data.id,formData);
      } else if (this.data.type === RolesEnum.SKUList) {
        serviceTarget = this.skuService.importExcelFile(formData);
      } else if (this.data.type === RolesEnum.BusinessPartnersList) {
        serviceTarget = this.businessPartnersService.importExcelFile(formData);
      }

      serviceTarget.subscribe((res:any) => {
        this.loading = false;
        if(res && res.status && res.message ==='OK'){
          this.toastr.success('', this.translate.instant('swalMsg.success'), { progressBar: true })
          this.dialogRef.close(true);
        }
        else {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('swalMsg.failed'),
            text: res.message,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.ok'),
          });
        }
      }, err => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.failed'),
          text: err,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.ok'),
        });
        console.error(err);
      });
    }
  }

  downloadFile() {
    this.downloadLoader = true;
    let serviceTarget = this.inboundService.downloadFile();
    let fileName = 'InboundNote_Template';
    if (this.data.type === RolesEnum.OutboundNotesList) {
      serviceTarget = this.outboundService.downloadFile();
      fileName = 'OutboundNote_Template';
    } else if (this.data.type === RolesEnum.LocationsList) {
      serviceTarget = this.locationService.downloadFile();
      fileName = 'Location_Template';
    } else if (this.data.type === RolesEnum.SKUList) {
      serviceTarget = this.skuService.downloadFile();
      fileName = 'SKU_Template';
    } else if (this.data.type === RolesEnum.BusinessPartnersList) {
      serviceTarget = this.businessPartnersService.downloadFile();
      fileName = 'BusinessPartners_Template';
    }
    
    serviceTarget.subscribe(
      data => {
        this.downloadLoader = false;
        if (data) {
          // console.log(fileName);
          this.sharedService.saveAsExcelFile(data, fileName);
        }
      },
      error => {
        this.downloadLoader = false;
        // console.log('Try again!, ' + error);
        Swal.fire({
          title: this.translate.instant('swalMsg.failed'),
          text: error.title,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.ok'),
        });
      });
  }

}
